<template>
    <v-app>
        <header-card-public current_page="landing"></header-card-public>
        <v-content class="bg-container fade">
            <v-layout fill-height row wrap>
                <!-- Left/top Side: Ads -->
                <v-flex v-if="!isMobile" xs12 sm6 class="ads-section">
                    <div class="ads-bg">
                        <public-notifications></public-notifications>
                    </div>
                </v-flex>

                <!-- Right/bottom Side: Welcome Card -->
                <v-flex xs12 sm6 :class="welcomeSectionClass">
                    <v-layout fill-height align-center justify-center>
                        <v-card :class="isMobile ? 'welcome-card-mobile' : 'welcome-card'">
                            <v-card-text style="height:auto;">
                                <h3
                                    class="subheading text-xs-center white--text"
                                    style="margin-bottom:20px;"
                                    v-html="welcome"
                                ></h3>
                                <v-btn :color="welcomeButtonColor" block dark @click="gotoLogin">Login</v-btn>
                            </v-card-text>
                        </v-card>

                        <div class="footer-section caption">
                            <div class="white--text text-xs-center">
                                &copy; Copyright 2024 SweldoNow OPC. All Rights Reserved.
                            </div>
                            <other-legal-docs></other-legal-docs>
                        </div>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-content>
    </v-app>
</template>

<script>
import '@/assets/css/public.css'
import '@/assets/css/season.css'
import publicPages from '@/helpers/public-pages.js'

export default {
    name: 'Home',
    metaInfo: {
        title: 'Home',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: '' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        ],
    },
    components: {
        'header-card-public': () => import('@/components/Common/HeaderPublic'),
        'other-legal-docs': () => import('@/components/Common/OtherLegalDocs'),
        'public-notifications': () => import('@/components/Common/PublicNotifications'),
    },
    data() {
        return {
            loading: false,
            disabled: false,
            seasonDetails: null,
        };
    },
    methods: {
        gotoLogin() {
            this.$router.push('login')
        },
        getTimeGreeting() {
            const hour = new Date().getHours();
            if (hour < 12) return "Good morning";
            if (hour < 18) return "Good afternoon";
            return "Good evening";
        },
    },
    created() {
        this.seasonDetails = publicPages.getSeasonDetails(this.$store.state.firstName)
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600;
        },
        welcome() {
            const firstName = this.$store.state.firstName;
            const action = this.$route.query.action;

            if (action === 'expired' || action === 'expired_token') {
                return "You've been logged out due to inactivity";
            } else if (action === 'change_password') {
                return "Your password has been successfully changed";
            } else if (action === 'user_initiated') {
                return "You've been logged out successfully";
            }

            if (firstName) {
                if (this.seasonDetails.greeting) {
                    return this.seasonDetails.greeting
                } else {
                    return `${this.getTimeGreeting()}, <strong>${firstName}</strong>!`;
                }
            }

            if (this.seasonDetails.greeting) {
                return `${this.seasonDetails.greeting}!`;
            }

            return "Welcome to <strong>SweldoNow</strong>";
        },
        welcomeSectionClass() {
            return this.isMobile ? this.seasonDetails.classNameMobile : this.seasonDetails.className
        },
        welcomeButtonColor() {
            return this.seasonDetails.buttonColor
        }
    },
};
</script>

<style scoped>
/* Shared styling for cards */
.welcome-card, .welcome-card-mobile {
    transition: all 0.5s ease;
    animation: fadeInUp 0.8s ease;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
